module.exports = __webpack_public_path__ + "/login_ui/img/gd-70be022bfee30f7bfc25f68b4a7a3ff7.svg";